module.exports = __webpack_public_path__ + "static/media/25-active.238ae8e8.png";